import { Factory } from 'fishery'
import { v4 as uuidV4 } from 'uuid'
import { OpalApiComponent } from '@opallabs/api'

type ViewColumnResourceV3 = OpalApiComponent<'V3', 'view_column'>

export const viewColumnResourceFactory: Factory<ViewColumnResourceV3> =
  Factory.define<ViewColumnResourceV3>(({ sequence }) => {
    return {
      id: uuidV4(),
      type: 'view_column',
      attributes: {
        position: sequence,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      },
      // All three relationships are optional in the schema; let tests override
      // them per-call rather than fabricating placeholders that misrepresent
      // which kind of column (standard vs CF) the row is backed by.
      relationships: {},
    } satisfies ViewColumnResourceV3
  })
